var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('desktop-registration',{staticClass:"d-none d-lg-block"}),_vm._v(" "),_c('mobile-registration',{staticClass:"d-block d-lg-none"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }